import { DropdownWithoutOptionsProps } from "components/dropdowns/models";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import React from "react";
import { type TimeOption, timeOptions } from "../models";

export default (props: DropdownWithoutOptionsProps<number, TimeOption>) => {
  const options: TimeOption[] = [
    { text: RESX.Advancing.NoValue, value: 0 },
    ...timeOptions
  ];

  return <BaseReactSelectDropdown
    options={options}
    value={options.find(o => o.value === props.value)}
    onChange={v => { props.onChange(v.value); }}
    getLabel={o => o.text}
    getValue={o => o.value}
    excludeKeys={[]}
    config={{
      isSearchable: false,
      shouldRenderSelectedValue: true,
      ...props.config,
    }}
  />
};
